import classnames from 'classnames'
import React from 'react'
import s from './StatusMessage.less'

const StatusMessage = ({ message, visible = false, className }) => {
  if (__SERVER__) return <></>
  return (
    <div className={classnames(s.status, visible && s.statusVisible, className)}>
      <span className={s.statusText}>{message}</span>
    </div>
  )
}

export default StatusMessage
